import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Tailwind class merger.
 * Conditional classes + duplicate Tailwind utility'leri akıllıca birleştirir.
 *
 * @example
 * cn("px-4 py-2", isActive && "bg-ok-primary", className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
